export const CollectionItemEntities = {
    COLLECTION: 'collection',
    WORKBOOK: 'workbook',
    ENTRY: 'entry',
} as const;
